// supportportal_web login
export const API_SUPPORT_PORTAL_LOGIN = '/cms/api/auth/login';

// verifyOtp
export const API_SUPPORT_PORTAL_VERIFY_OTP = '/cms/api/auth/verifyOtp';

// Invalidate token
export const API_INVALIDATE_TOKEN = '/cms/api/auth/logout';

//getAllusers
export const API_GET_ALL_USERS = '/cms/api/users';

//createUser
export const API_CREATE_USER = '/cms/api/auth/register';
export const API_GET_ROLE_ID = '/cms/api/table?name=account_role';

//delete user
export const API_DELETE_USER = '/cms/api/users';

//Edit user
export const API_UPDATE_USER = '/cms/api/users';

//get role
export const API_GET_ACCOUNT_ROLES = '/cms/api/accountRoles';

//creat role 
export const API_CREATE_ROLE = '/cms/api/accountRoles';
export const API_GET_ROLE_GRADE = '/cms/api/table?name=account_grade';

//delete role 
export const API_DELETE_ROLE = '/cms/api/accountRoles?roleId=';

//update role
export const API_UPDATE_ROLE = '/cms/api/accountRoles/update';

//digital price - get list
export const API_DIGITAL_PRICE_FETCH_LIST = '/cms/api/priceTagSettings/getListAllDistData';

// get list all select shop distribution data
export const API_DIGITAL_PRICE_FETCH_LIST_SELECT_SHOP = '/cms/api/priceTagSettings/getListAllSelectShopDistData';

//upload excel
export const API_UPLOAD_EXCEL = '/cms/api/priceTagSettings/import';

// update digital price tag data
export const API_UPDATE_DIGITAL_PRICE_TAG_DATA = '/cms/api/priceTagSettings/updateDigitalPriceTagData';

// digital price-get list all distribution data in Excel format
export const API_DIGITAL_PRICE_FETCH_LIST_EXCEL = '/cms/api/priceTagSettings/getListAllDistExcel';

// get all shop list
export const API_GET_ALL_SHOP_LIST = '/cms/api/priceTagSettings/getAllShopList';

// get resource by content type
export const API_GET_RESOURCE_BY_CONTENT_TYPE = '/cms/api/resource?contentType=page';

// get resource packages by ID and language
export const API_GET_RESOURCE_PACKAGES = '/cms/api/resource/packages';

// get specific resource package by ID
export const API_GET_RESOURCE_PACKAGE_BY_ID = '/cms/api/resource/packages';

// add resource
export const API_ADD_RESOURCE = '/cms/api/resource/add';

//update resource
export const API_UPDATE_RESOURCE = '/cms/api/resource/update';

//Products
export const API_GET_PRODUCTS = '/cms/api/products';
export const API_CREATE_PRODUCTS = '/cms/api/products';
export const API_DELETE_PRODUCTS = '/cms/api/products';
export const API_GET_PRODUCT = '/cms/api/products';
export const API_UPDATE_PRODUCT = '/cms/api/products';

//Packages
export const API_GET_PACKAGES = '/cms/api/packages';
export const API_CREATE_PACKAGES = '/cms/api/packages';
export const API_DELETE_PACKAGES = '/cms/api/packages';
export const API_GET_PACKAGE = '/cms/api/packages';
export const API_UPDATE_PACKAGE = '/cms/api/packages';
export const API_UPDATE_PACKAGE_PRODUCTS = '/cms/api/packages';

//Asset
export const API_GET_FILE = '/cms/api/asset';
export const API_UPLOAD_FILE = '/cms/api/asset/upload';
export const API_DELETE_FILE = '/cms/api/asset/delete';

// get code dictionaries by region and type
export const API_GET_CODE_DICTIONARIES = '/cms/api/code-dictionaries';

// get specific package products by package ID
export const API_GET_PACKAGE_PRODUCTS_BY_ID = '/cms/api/packages';

export const API_GET_PROMO_CODES = '/cms/api/promocodes';

export const API_EXPORT_PROMO_CODES = '/cms/api/promocodes/export';

// order query
export const API_ORDER_QUERY = '/cms/api/orderquery';

// eSIM query
export const API_ESIM_QUERY = '/cms/api/esimquery';

export const API_ORDER_QUERY_RESEND = '/cms/api/orderquery/resend';